import { getFileIconSettings } from '@/helpers/files'

import { Node } from '@/classes/Documents/Node.class'
import { DocumentVersion } from '@/classes/Documents/DocumentVersion.class'

export class Document extends Node {
	icon = {
		color: 'primary',
		icon: 'fas fa-file-alt'
	}

	constructor(rawNode) {
		super(rawNode)
		if (this.deleted_at != null) {
			this.folder_id = -1
		}
		const foundIconSetting = getFileIconSettings(this.type)
		if (foundIconSetting) {
			Object.assign(this.icon, foundIconSetting)
		}
		delete this._folders
		delete this._documents
	}

	get versions() {
		return this._versions
	}
	set versions(versions) {
		if (Array.isArray(versions)) {
			versions.forEach(version => {
				this.addOrUpdateVersion(version)
			})
		}
	}

	get firstVersion() {
		let result = null
		if (this.versions) {
			if (this.versions.length == 1) {
				result = this.versions[0]
			} else if (this.versions.length > 1) {
				result = this.nextVersion(null)
			}
		}
		return result
	}

	get latestVersion() {
		let result = null
		if (this.versions) {
			if (this.versions.length == 1) {
				result = this.versions[0]
			} else if (this.versions.length > 1) {
				let currentVersion = this.firstVersion
				while (currentVersion != null) {
					result = currentVersion
					currentVersion = this.nextVersion(currentVersion)
				}
			}
		}
		return result
	}

	get isValidated() {
		let result = false
		if (this.latestVersion) {
			result = this.latestVersion.validated_at != null
		} else if (this.validated_at != null) {
			result = true
		} else {
			result = this.is_validated
		}
		return result
	}

	update(rawNode) {
		if (rawNode && rawNode !== this && typeof rawNode.is_validated === 'boolean' && this.latestVersion) {
			const cachedIsValidated = this.latestVersion.validated_at != null
			if (cachedIsValidated !== rawNode.is_validated) {
				this._versions = []
			}
		}
		return super.update(rawNode)
	}

	get start_date() {
		return this.latestVersion?.created_at ?? this.updated_at
	}

	getVersion(version) {
		let result = null
		if (this.versions) {
			result = this.versions.find(existingVersion => existingVersion.id == version.id)
		}
		return result
	}
	addOrUpdateVersion(version) {
		let newVersion
		if (!this.versions || !this.versions.map(existingVersion => existingVersion.id).includes(version?.id)) {
			newVersion = this.addVersion(version)
		} else {
			newVersion = this.updateVersion(version)
		}
		return newVersion
	}
	addVersion(version) {
		if (!Array.isArray(this._versions)) {
			this._versions = []
		}
		version = new DocumentVersion(version)
		if (!this._versions.map(({ id }) => id).includes(version.id)) {
			this._versions.push(version)
			this.__sortVersions()
		}
		return version
	}
	updateVersion(version) {
		const currentVersion = this.versions ? this.versions.find(existingVersion => existingVersion.id === version.id) : null
		if (currentVersion) {
			currentVersion.update(version)
		}
		return currentVersion
	}
	removeVersion(version) {
		const currentVersionIndex = this.versions ? this.versions.findIndex(existingVersion => existingVersion.id === version.id) : -1
		if (currentVersionIndex > -1) {
			this.versions.splice(currentVersionIndex, 1)
		}
		this.__sortVersions()
	}
	__sortVersions() {
		if (Array.isArray(this._versions)) {
			this._versions.sort((versionA, versionB) => versionB.id - versionA.id)
			const numberOfVersions = this._versions.length
			this._versions.forEach((version, index) => {
				version.number = numberOfVersions - index
			})
		}
	}
	previousVersion(currentVersion) {
		let result = null
		if (currentVersion && currentVersion.ancestor_id && this.versions) {
			result = this.versions.find(version => version.id == currentVersion.ancestor_id)
		}
		return result
	}
	nextVersion(currentVersion) {
		let result = null
		if (!currentVersion) {
			result = this.versions?.find(version => version.ancestor_id == null)
		} else if (currentVersion.id) {
			result = this.versions?.find(version => version.ancestor_id == currentVersion.id)
		}
		return result
	}
	removeCounter() {
		this._counter = 0
	}
	toString(indentation = '') {
		return indentation + this.name
	}
}
